// @flow

import styled from 'styled-components';
import { FONT_WEIGHT_400 } from 'styles/font-weight';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import { SPACING_MEDIUM } from 'styles/spacing';

export const ClientName = styled.div`
  ${FONT_WEIGHT_400};
  ${LINE_HEIGHT_COPY};
`;

export const Details = styled.div`
  ${LINE_HEIGHT_COPY};
  padding-left: ${SPACING_MEDIUM};
`;



// WEBPACK FOOTER //
// ./src/components/sessions/list/scheduled/row/styles.js